export default function FlattenerHero() {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-teal-900 to-cyan-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center bg-teal-500/20 backdrop-blur-sm border border-teal-400/30 rounded-full px-4 py-2 mb-6">
              <span className="text-teal-300 text-sm font-semibold">命令行工具</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              PDF Forms Flattener™
            </h1>
            
            <h2 className="text-2xl lg:text-3xl font-semibold text-teal-300 mb-6">
              扁平化AcroForm、静态XFA和动态XFA文档
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              专业的命令行工具，可程序化地填充和扁平化表单内容为标准的扁平化PDF文档。无论您使用的是AcroForms、静态XFA还是动态XFA表单，都能确保在所有设备上保持一致的查看体验。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a 
                href="#pricing" 
                className="inline-flex items-center justify-center bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                免费试用
              </a>
              <a 
                href="/contact" 
                className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                联系销售
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
              <div className="text-sm text-gray-300 mb-2">起始价格</div>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl font-bold text-yellow-400">¥20,843</span>
                <span className="text-lg text-gray-300">/年</span>
                <span className="text-sm text-gray-400">（内部使用）</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 shadow-2xl">
              <div className="aspect-video bg-gradient-to-br from-teal-500/20 to-cyan-500/20 rounded-lg flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-file-pdf-2-line text-8xl text-teal-300 mb-4"></i>
                  <div className="text-xl font-semibold text-white">表单扁平化处理</div>
                  <div className="text-sm text-gray-300 mt-2">支持所有表单类型</div>
                </div>
              </div>
              
              <div className="mt-6 grid grid-cols-3 gap-4">
                <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-file-list-3-line text-3xl text-teal-300 mb-2"></i>
                  <div className="text-xs text-gray-300">AcroForm</div>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-file-text-line text-3xl text-cyan-300 mb-2"></i>
                  <div className="text-xs text-gray-300">静态XFA</div>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-file-code-line text-3xl text-blue-300 mb-2"></i>
                  <div className="text-xs text-gray-300">动态XFA</div>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-500/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-cyan-500/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
